export const environment = {
    production: false,
    apiBaseUrl: '/api',
    firebase: {
        apiKey: 'AIzaSyBgXsKA8GLQrZTmpIqQnveqfpKhtDZSfFI',
        authDomain: 'auth-dev.restomator.com',
        projectId: 'restomator-dev',
        storageBucket: 'restomator-dev.firebasestorage.app',
        messagingSenderId: '512022886253',
        appId: '1:512022886253:web:77db75cab34ad9dce84c64',
    },
    authProviders: {
        emailPassword: true,
        google: true,
        facebook: true,
        apple: false,
    },
    redirect: {
        allowHttpOnLocalhost: true,
        allowedHosts: [] as string[],
    },
} as const;
